import React, { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Homepage from "./pages/Homepage";
import Simulator from "./pages/Simulator";
import SalleDeBain from "./pages/SalleDeBain";
import Accessibilite from "./pages/Accessibilite";
import Exterieurs from "./pages/Exterieurs";
import MaPrimeAdapt from "./pages/MaPrimeAdapt";
import Contact from "./pages/Contact";
import MentionsLegales from "./pages/MentionsLegales";
import PolitiqueConfidentialite from "./pages/PolitiqueConfidentialite";
import AccesPro from "./pages/AccesPro";
import Partenaires from "./pages/Partenaires";
import CumulAidesIDF from "./pages/CumulAidesIDF";
import AidesComplementaires from "./pages/AidesComplementaires";
import AMOParis75 from "./pages/AMOParis75";
import AMOSeineEtMarne77 from "./pages/AMOSeineEtMarne77";
import AMOEssonne91 from "./pages/AMOEssonne91";
import AMOHautsDeSeine92 from "./pages/AMOHautsDeSeine92";
import AMOSeineSaintDenis93 from "./pages/AMOSeineSaintDenis93";
import AMOValDOise95 from "./pages/AMOValDOise95";
import AvisMaPrimeAdapt from "./pages/AvisMaPrimeAdapt";
import GuideMaPrimeAdapt from "./pages/GuideMaPrimeAdapt";
import ContactAMOANAH from "./pages/ContactAMOANAH";
import PageIntrouvable from "./pages/PageIntrouvable";
import MonteEscalier from "./pages/MonteEscalier";
import Aidants from "./pages/Aidants";
import PlafondsRessources from "./pages/PlafondsRessources";
import Blog from "./pages/Blog";
import ArticleBlog from "./pages/ArticleBlog";
// Pages d'atterrissage Google Ads : en-tête réduit, sans navigation, en
// noindex et hors sitemap pour ne pas concurrencer les pages organiques.
import LandingSalleDeBain from "./pages/LandingSalleDeBain";
import LandingMonteEscalier from "./pages/LandingMonteEscalier";
import LandingSeniors from "./pages/LandingSeniors";
import ScrollToTop from "./components/ScrollToTop";
import CookieConsent from "./components/CookieConsent";
import ScrollToTopOnRouteChange from "./components/ScrollToTopOnRouteChange";
import { trackPageView } from "./utils/analytics";
import { memoriserProvenance } from "./utils/attribution";

// Composant pour tracker les changements de page
function AnalyticsTracker() {
  const location = useLocation();

  // La provenance se relève une fois, au tout premier rendu : à ce moment
  // seulement, l'URL porte encore les UTM et document.referrer désigne encore
  // le site d'où l'on vient. Le faire dans l'effet dépendant de `location`
  // écraserait le relevé à chaque changement de page.
  useEffect(() => {
    memoriserProvenance();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search, document.title);
  }, [location]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <AnalyticsTracker />
          <ScrollToTopOnRouteChange />
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/simulateur" element={<Simulator />} />
            <Route path="/salle-de-bain" element={<SalleDeBain />} />
            <Route path="/accessibilite" element={<Accessibilite />} />
            <Route path="/exterieurs" element={<Exterieurs />} />
            <Route path="/maprimeadapt" element={<MaPrimeAdapt />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mentions-legales" element={<MentionsLegales />} />
            <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
            <Route path="/acces-pro" element={<AccesPro />} />
            <Route path="/partenaires" element={<Partenaires />} />
            <Route path="/cumul-aides-ma-prime-adapt-idf" element={<CumulAidesIDF />} />
            <Route path="/aides-complementaires" element={<AidesComplementaires />} />
            <Route path="/amo-anah-paris-75" element={<AMOParis75 />} />
            <Route path="/amo-anah-seine-et-marne-77" element={<AMOSeineEtMarne77 />} />
            <Route path="/amo-anah-essonne-91" element={<AMOEssonne91 />} />
            <Route path="/amo-anah-hauts-de-seine-92" element={<AMOHautsDeSeine92 />} />
            <Route path="/amo-anah-seine-saint-denis-93" element={<AMOSeineSaintDenis93 />} />
            <Route path="/amo-anah-val-doise-95" element={<AMOValDOise95 />} />
            <Route path="/avis-maprimeadapt" element={<AvisMaPrimeAdapt />} />
            <Route path="/guide-ma-prime-adapt" element={<GuideMaPrimeAdapt />} />
            <Route path="/contact-amo-anah" element={<ContactAMOANAH />} />
            <Route path="/monte-escalier" element={<MonteEscalier />} />
            <Route path="/aidants" element={<Aidants />} />
            <Route path="/plafonds-ressources-maprimeadapt" element={<PlafondsRessources />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<ArticleBlog />} />
            <Route path="/adaptation-salle-de-bain-idf" element={<LandingSalleDeBain />} />
            <Route path="/monte-escalier-aide-anah-idf" element={<LandingMonteEscalier />} />
            <Route path="/maprimeadapt-personnes-agees-idf" element={<LandingSeniors />} />
            <Route path="*" element={<PageIntrouvable />} />
          </Routes>
          <ScrollToTop />
          <CookieConsent />
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
